var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "spa-soft component" },
    [
      _c("BookingHeader", {
        attrs: {
          languages: _vm.languages,
          "additional-data": _vm.bookingHeaderAdditionalData,
          "skip-booking-tracking": true,
        },
      }),
      _vm._v(" "),
      _c("SpaSoftProgressBar"),
      _vm._v(" "),
      _vm.isDataLoaded
        ? [
            _c("SpaSoftHeaderDetail"),
            _vm._v(" "),
            _vm.shouldShowMastheadAndTitle ? _c("SpaSoftMasthead") : _vm._e(),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "fade" } },
              [
                _c(
                  "router-view",
                  _vm._b(
                    { staticClass: "spa-soft-page" },
                    "router-view",
                    _vm.bindings,
                    false
                  )
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("SpaSoftFooter"),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isLocalhostWithoutHotelCode
        ? [
            _c("h4", { staticClass: "container" }, [
              _vm._v(
                "\n      localhost: Hotel code is missing in the URL query, example: ?hotelCode=510\n    "
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "overlay",
        {
          attrs: {
            "overlay-id": "spa-soft",
            "overlay-background-color": "black",
            "overlay-background-opacity": "0.72",
            "content-width": 800,
            "content-height": _vm.isMobile ? 420 : 800,
          },
        },
        [
          _c(
            "div",
            { staticClass: "overlay-wrapper", attrs: { role: "status" } },
            [
              _c("div", { staticClass: "overlay-image icon-fan-logo" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sr-only overlay-title",
                  attrs: { id: "check-availability-title" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.tc("spaSoft.step1.overlayLoading")) +
                      "\n      "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }